import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-truck-loading mr-1" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Deliver creatives ")
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { useDelivery } from '@/composables/delivery';



export default /*#__PURE__*/_defineComponent({
  props: {
    campaignId: null
  },
  setup(__props: any) {

const props = __props as {
    campaignId: string;
}



const { deliver } = useDelivery(props.campaignId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(deliver) && _unref(deliver)(...args))),
    class: "btn btn-warning"
  }, _hoisted_3))
}
}

})